import React, { useState, useEffect } from "react";
import { styled } from '@mui/material/styles';
import Banner from './../components/Banner';
import Background from './../../images/background.svg'
import Footer from './../components/Footer';
import Loading from '../components/Loading'

import {
    Grid,
    Paper,
    FormGroup,
    TextField,
    Button,
    Divider
} from '@mui/material';


const PREFIX = 'SignUp';

const classes = {
    root: `${PREFIX}-root`,
    textfield: `${PREFIX}-textfield`,
    button: `${PREFIX}-button`,
    paper: `${PREFIX}-paper`,
    textlabel: `${PREFIX}-textlabel`,
    link: `${PREFIX}-link`,
    footer: `${PREFIX}-footer`
};


const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        flexGrow: 1,
        height: "120vh",
        background: "url(" + Background + ") no-repeat center bottom fixed",
        backgroundSize: "cover",
    },

    [`& .${classes.textfield}`]: {
        backgroundColor: "#fff",
    },

    [`& .${classes.button}`]: {
        width: "100%",
        textTransform: "none"
    },

    [`& .${classes.paper}`]: {
        margin: theme.spacing(4),
        borderStyle: "solid",
        backgroundColor: "#eee",
        borderWidth: "thin",
        borderColor: "#ddd",
        padding: "5%",
        boxShadow: "none"
    },

    [`& .${classes.textlabel}`]: {
        textAlign: "left"
    },

    [`& .${classes.link}`]: {
        color: theme.palette.primary.main
    },

    [`& .${classes.footer}`]: {
        position: 'fixed',
        bottom: 0,
        margin: "20px",
    }
}));

function SignUp() {



    const [email, setEmail] = useState("");
    const [customerNumber, setCustomerNumber] = useState("");
    const [crn, setCrn] = useState("");
    const [loading, setLoading] = useState(true);
    const [loadconfirmNewSignup, setLoadconfirmNewSignup] = useState(false);

    function validateForm() {
        return customerNumber.length > 0 && crn.length > 0 && email.length > 0 && email.includes("@");
    }


    useEffect(() => {
        setLoading(false)
    }, []);

    let signupRequest = <div id="signupRequest">
        <form onSubmit={handleSignupSubmit} id="signupRequest">
            <div className={classes.textlabel}>
                <h4>To register for My Account Large Business:</h4>
                <p style={{ paddingLeft: "2em" }}>1. Enter your email address and customer details in the boxes below.</p>
                <p style={{ paddingLeft: "2em" }}>2. We&apos;ll send you an email with instructions.</p>
                <p style={{ paddingLeft: "2em" }}>3. Sign in to the application using the instructions and follow the link.</p>
            </div>
            <FormGroup>
                <p className={classes.textlabel}>Email</p>
                <TextField className={classes.textfield} inputProps={{ "data-testid": "email-signup" }} variant="outlined" type="email" onChange={e => setEmail(e.target.value)} />
            </FormGroup>
            <FormGroup>
                <p className={classes.textlabel}>Account Number</p>
                <TextField className={classes.textfield} inputProps={{ "data-testid": "customer-number-signup" }} variant="outlined" onChange={e => setCustomerNumber(e.target.value)} />
            </FormGroup>
            <FormGroup>
                <p className={classes.textlabel}>Customer Number</p>
                <TextField className={classes.textfield} inputProps={{ "data-testid": "crn-signup" }} variant="outlined" onChange={e => setCrn(e.target.value)} />
            </FormGroup>
            <br />
            <Divider />
            <br />
            <Button className={classes.button} variant="contained" color="primary" type="submit" disabled={!validateForm()}>
                Submit
        </Button>
        </form>
    </div>

    let confirmNewSignup = <div id="formVerification">
        <form onSubmit={handleRevert} id="signupRequest">
            <h2>Done! You have successfully registered!</h2>
            <h3>Please check your email for further instructions.</h3>
            <br />
            <Divider />
            <br />
            {/* TODO go to tally page on redirect */}
            <Button className={classes.button} variant="contained" color="primary" type="submit">
                Click here to Sign In
            </Button>
        </form>
    </div >

    let displayForm;
    let bannerText;
    bannerText = "Register for My Account Large Business";
    if (loadconfirmNewSignup === true) {
        displayForm = confirmNewSignup;
    } else {
        displayForm = signupRequest;
    }

    function handleRevert(event) {
        event.preventDefault();
        setLoadconfirmNewSignup(false);
        window.location.href = window.location.origin;
    }

    function handleSignupSubmit(event) {
        setLoading(true);
        event.preventDefault();

        let statusCode;
        let userDetails = {
            type: "signup",
            email: email,
            account_number: customerNumber,
            customer_reference_number: crn
        };
        fetch(
            window.location.origin + `/register-api`,
            {
                method: "POST",
                headers: new Headers({
                    Accept: "application/json"
                }),
                body: JSON.stringify(userDetails)
            }
        )
            .then(res => {
                statusCode = res.status;
                return res.json();
            })
            .then(response => {
                if (statusCode === 200) {
                    setLoadconfirmNewSignup(true);
                    setLoading(false);
                } else {
                    response = JSON.stringify(response);
                    alert(`Could not complete signup: ${response}`);
                    setLoading(false);
                    throw new Error(`Could not complete signup: ${response}`);
                }
            })
            .catch(error => {
                console.log(error);
                const registrationHelpMessage = `We're unable to complete your registration online.\n\nPlease check that:\n• your account number and customer ID are correct\n• the account number you've entered is active\n\nStill having trouble registering? Try logging in instead, or use 'Forgot your password?' – you might already be registered with us.\n\nIf you need further help, email us at businessenq@energyaustralia.com.au`;
                window.alert(registrationHelpMessage);
                setLoading(false);
            });
    }


    let signupContainer;
    if (loading === true) {
        signupContainer = <Loading />;
    } else {
        signupContainer = <div>
            <Grid container spacing={0}>
                <Grid item xs={false} sm={2} md={3}><div></div></Grid>
                <Grid item xs={12} sm={8} md={6} >
                    <Paper className={classes.paper}>
                        {displayForm}
                    </Paper>
                </Grid>
                <Grid item xs={false} sm={2} md={3}>
                    <div></div>
                </Grid>
            </Grid>
            <Footer className={classes.footer} />
        </div>
    }

    return ( 
        <Root className={classes.root}>
            <Banner title={bannerText} />
            {signupContainer}
        </Root>

    );
}

export default SignUp;


